import { render, staticRenderFns } from "./xxzxDetailBanKuai.vue?vue&type=template&id=746a6f3b&scoped=true"
import script from "./xxzxDetailBanKuai.vue?vue&type=script&lang=js"
export * from "./xxzxDetailBanKuai.vue?vue&type=script&lang=js"
import style0 from "./xxzxDetailBanKuai.vue?vue&type=style&index=0&id=746a6f3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a6f3b",
  null
  
)

export default component.exports